// =============================================================================
// Credential
// =============================================================================
export const CREDENTIAL_PROVIDERS = [
    'hetzner',
    'scaleway',
    'gcp',
    'vultr',
    'infomaniak',
    'digitalocean',
    'upcloud',
];
// =============================================================================
// GCP OIDC Credential (stored after Connect GCP flow)
// =============================================================================
export const GCP_CREDENTIAL_VERSION = 1;
//# sourceMappingURL=user.js.map